<template>

  <div class="kb"  ref="platformBox">
    <div class="plate-number">
      <div class="item" :class="[activeIndex==0?'active':'',isEnergy?'energy':'normal']"  @click="inputKeyboard(0,1)">{{plateNumber[0]}}</div>
      <div class="item" :class="[activeIndex==1?'active':'',isEnergy?'energy':'normal']" @click="inputKeyboard(1,2)">{{plateNumber[1]}}</div>
      <div class="item item-dot">
        <div class="dot" :class="[isEnergy?'dotenergy':'dotnormal']"></div>
      </div>
      <div class="item" :class="[activeIndex==2?'active':'',isEnergy?'energy':'normal']" @click="inputKeyboard(2,3)">{{plateNumber[2]}}</div>
      <div class="item" :class="[activeIndex==3?'active':'',isEnergy?'energy':'normal']" @click="inputKeyboard(3,3)">{{plateNumber[3]}}</div>
      <div class="item" :class="[activeIndex==4?'active':'',isEnergy?'energy':'normal']" @click="inputKeyboard(4,3)">{{plateNumber[4]}}</div>
      <div class="item" :class="[activeIndex==5?'active':'',isEnergy?'energy':'normal']" @click="inputKeyboard(5,3)">{{plateNumber[5]}}</div>
      <div class="item" :class="[activeIndex==6?'active':'',isEnergy?'energy':'normal']" @click="inputKeyboard(6,3)">{{plateNumber[6]}}</div>
      <div class="item-new-energy" :class="[activeIndex==7?'active':'',isEnergy?'energy':'hasval']" @click="inputKeyboard(7,3)">
        <div class="txt" style="text-align: center;width:100%" v-if="activeIndex==7||plateNumber[7]"> {{plateNumber[7]}} </div>
        <div class="txt txt-tip" v-else>
          <img class="ico" src="../assets/images/Group261.png" alt="" srcset="">
          <div class="tit">新</div>
        </div>
      </div>
    </div>

    <div class="keyboard-popup" v-show="show" :data-key="time">

      <div class="kb-keyboard">
        <div class="kb-keyboard-provs flex-brick" v-show="mode==1">
          <div class="kb-keyboard_td" v-for="item in provinces" @click="tapKeyboard" :data-val="item">{{item}}</div>
        </div>
        <div class="kb-keyboard-nums flex-brick" v-show="mode==2">
          <div class="kb-keyboard_td" :class="{disabled:activeIndex==1 }" v-for="item in numbers" @click="tapKeyboard"
            :data-val="item">{{item}}</div>
        </div>
        <div class="kb-keyboard-letters flex-brick" v-show="mode==2">
          <div class="kb-keyboard_td" :class="{disabled:item.disabled }" v-for="item in letters"
            @click="tapKeyboard" :data-val="item.name">{{item.name}}</div>
        </div>
        <div class="kb-keyboard-action flex-brick">
          <div class="kb-keyboard_td kb-keyboard__del" @click="tapDelete">
            <div class="ico-del"></div>
          </div>
          <div class="kb-keyboard_td kb-keyboard__finished" @click="tapFinish">确定</div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  export default {

    name: "CarNumberText",

    props: {


      //车牌号码
      plateNumber: {
        type: Array,
        default: ()=>["", "", "", "", "", "", "", ""]
      }


    },
    data() {


      return {

        //显示
        show: false,

        //省份
        provinces: "京津沪冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤川青藏琼宁渝",

        //字母
        letters: "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("").map(x=>({name:x,disabled:false})),

        //数字
        numbers: "0123456789",

        //当前输入索引
        activeIndex: -1,

        /*
        键盘模式 0 关闭状态  1 显示省份输入 2 显示数字和字母输入
        */
        mode: 0,

        //变动时间截
        time: 0,
        isEnergy:false
      };
    },
    // computed: {
    //   isEnergy () {
    //     return this.plateNumber[this.plateNumber.length-1] || this.activeIndex===7
    //   }
    // },
    created() {
      let plateNumber = this.plateNumber;
      if (plateNumber.length < 8) {
        for (let i = 0; i < 8; i++) {
          if (plateNumber[i] === undefined) {
            plateNumber[i] = '';
          }
        }
        this.updateData(plateNumber);

      }
    },
    mounted(){
      document.addEventListener('click',this.platformShow,true)
    },
    methods: {
      platformShow(e){
        if(!this.$refs.platformBox.contains(e.target)){
            this.tapFinish()
        }
      },
      updateData(v) {
        this.$emit('update:plateNumber', v);
        this.$emit('change', v);
        this.time = +new Date();
      },
      checkCityDisabled(str) {
        return str === "I"
      },
      /** 标识输入框的位数
       * @param type {number} 键盘类型
       * 1：省份输入。键盘：省份简称。
       * 2：区号输入。键盘：数字+字母。数字和I不可选
       * 3：序号选择。键盘：数字+字母。I、O不可选
       * 4：特殊位数。键盘：数字+字母+特殊字符（'字'切换显示'学挂警'按钮）。I、O不可选
       * 5：新能源标识位。键盘：数字+字母。I、O不可选
       */

      inputKeyboard(index,type) {
        this.mode = index == 0 ? 1 : 2;
        this.activeIndex = index;
        this.isEnergy = index === 7 ||this.plateNumber[this.plateNumber.length-1];

        /** 第2位 区号选择 英文字母+数字 数字和I不可选 */
        if (type === 2) {
            this.letters = this.letters.map(e => ({
              name: e.name,
              disabled:  e.name === "I"
            }))
        }

      /** 第3-6位 序号选择 英文字母+数字 I、O不可选 */
      if (type === 3) {
        this.letters = this.letters.map(e => ({
            name: e.name,
            disabled: e.name === "I" || e.name === "O"
          }))
        }

        this.show = true;
      },

      tapDelete(e) {

        let activeIndex = this.activeIndex;
        let plateNumber = this.plateNumber;
        plateNumber[activeIndex] = '';

        if (activeIndex > 0) {
          this.inputKeyboard(activeIndex - 1);
        }
        this.updateData(plateNumber);

      },

      tapKeyboard(e) {

        let val = e.target.dataset.val;
        let activeIndex = this.activeIndex;
        let plateNumber = this.plateNumber;

        plateNumber[activeIndex] = val;

        if (activeIndex < 6) {
          const types = [1,2,3,3]
          const type = types[activeIndex + 1]||3;
          this.inputKeyboard(activeIndex + 1,type);
        } else {
          this.tapFinish();
        }
        this.updateData(plateNumber);
      },

      tapFinish(e) {
        this.show = false;
        this.mode = 0;
        this.activeIndex = -1;
      },
    },
  };
</script>

<style lang="less" scope>
@input-addition-active-color: #30cd30;
.plate-number {
  font-size: 20px;
  display: flex;
  justify-content: space-between;
}
.plate-number .item {
  width: 35px;
  height: 45px;
  text-align: center;
  box-sizing: border-box;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 2px;
}
.plate-number .item.normal {
  border: 1px solid #2F94FF;
}
.plate-number .item.energy {
  border: 1px solid #40CF38;
}
.plate-number .item-new-energy {
  width: 35px;
  height: 45px;
  display: flex;
  border-radius: 4px;
  align-items: center;
  box-sizing: border-box;
  border: 1px solid #40CF38;
}
.plate-number .hasval{
  background-color: #E9FCE8;
}
.plate-number .item-new-energy .ico {
  width: 14px;
  height: 14px;
  color: #31B72A;
  margin-bottom: 5px;
}
.plate-number .item-new-energy .tit {

  font-size: 12px;
  color: #000;
  width: 45px;
  text-align: center;
}
.plate-number .active {
  background-color: #D4E9FF;
  animation: breath 0.5s ease-in-out infinite;
  animation-direction: alternate;
}
.plate-number .active.normal {
  background-color: #D4E9FF;
  animation: breath 0.5s ease-in-out infinite;
  animation-direction: alternate;
}
.plate-number .active.energy {
  background-color: #D4E9FF;
  animation: breathEnergy 0.5s ease-in-out infinite;
  animation-direction: alternate;
}
.plate-number .item.item-dot {
  border: none;
  width: auto;
}
.plate-number .item.item-dot .dotnormal{
  background: #288DFA;
}
.plate-number .item.item-dot .dotenergy{
  background: #31B72A;
}
.plate-number .item.item-dot .dot {
  width: 4px;
  height: 4px;

  border-radius: 50%;
}
.keyboard-popup {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  background: #E7EEF6;
  z-index: 888;
}
.kb-keyboard {
  padding: 6px 2px;
  position: relative;
}
.flex-brick {
  display: flex;
  flex-flow: row wrap;
}
.kb-keyboard-action {
  display: flex;
  justify-content: space-between;
  position: absolute;
  bottom: 6px;
  right: 6px;
}
.kb-keyboard_td {
  color: #1e1e1e;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc((100vw - 64px) / 10);
  font-size: 18px;
  height: 41px;
  margin: 8px 3px;
  border-radius: 4px;
}
.kb-keyboard_td.disabled {
  opacity: 0.5;
  pointer-events: none;
}
.kb-keyboard_td:active {
  background: #f2f2f2;
}
.kb-keyboard__del {
  align-self: flex-end;
  width: 88px;
  height: 41px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 1PX;
}
.kb-keyboard__del .ico-del {
  width: 29px;
  height: 20px;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAeCAMAAABg6AyVAAAAclBMVEUAAAAwMDAxMTEMDAwpKSkpKSkwMDAqKioxMTExMTEpKSkqKiokJCQpKSkpKSkqKioqKioqKioqKioqKiopKSkoKCgoKCgnJycqKioqKioqKioqKioqKioqKioqKiorKysrKysoKCgqKioAAAAlJSUqKipvWYGQAAAAJXRSTlMA/lcC+OyZhmk+lioH8OXd1MlOPzQZDCDcvr2ysaWjajsTEgEiwq/YugAAAM9JREFUOMud1McWgyAQBdABKxp7S+/v/38xDUPAY/DwNs7iLoQZhoycCswkiFY69RL8SaTbA/yaZnJGQD9Z7ZA1NBuAVPoNgpaW4UuFPKVluCuxHmgZHgqUnTxmHAqSEWHsTXCao7rKOmaM8U/Jn2Vs4jbAtieZkL30aFlo4CbDXrVHsLeWlgkd1z6O3teOiMsPaZj7SG5EE62swqkvm25qZRWOkNAkfLTu2P4bzge0X51rU+ztdh0kmbtlRC3D7/Cs3B+s6yqwLxnX9WVfjA8P3SLCPZZ7QgAAAABJRU5ErkJggg==);
  background-size: 100% 100%;
}
.txt-tip{
  font-size: 12px;
  display: flex;
  padding-top: 2px;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}
.kb-keyboard__finished {
  width: calc(((100vw - 12px) / 10 - 12px) * 1.8);
}
@keyframes breathEnergy {
  from {
    background-color: #F4F6FA;
  }
  to {
    background-color: #E9FCE8;
  }
}
@keyframes breath {
  from {
    background-color: #F4F6FA;
  }
  to {
    background-color: #D4E9FF;
  }
}

</style>
